import React from 'react';
import {useIntl} from 'react-intl';

import {EditorWrapper} from './wrapper';

export const DeactivatedChannel = () => {
    const {formatMessage} = useIntl();

    return (
        <EditorWrapper>
            {formatMessage({
                id: 'editor_state.deactivated_channel_message',
                defaultMessage: 'The chat with the deactivated user is read-only',
            })}
        </EditorWrapper>
    );
};
